<template lang="pug">
.v-converter.converter(v-if="converter" :class="{'converter--simple': view === 'simple'}")
	.converter__form
		.converter__main
			.converter__main-wrap
				.converter__main-fields
					.converter__fields
						button.converter__btn-swap(type="button" @click="swapFields")
							v-svg-icon.converter__icon(icon="swap")
						.converter__field-wrap
							.converter__field.converter__field--sale.flc
								v-field(:field="converter.form.sale"
									v-model="converter.form.sale.value"
									@keyup="fieldChanged(converter.form.sale, $event)")
							.converter__field.converter__field--buying.flc
								v-field(:field="converter.form.buying"
									v-model="converter.form.buying.value"
									@keyup="fieldChanged(converter.form.buying, $event)")
							.converter__field.converter__field--sale-currency.flc
								v-field(:field="converter.form.saleCurrency"
									v-model="converter.form.saleCurrency.value"
									@update:model-value="fieldChanged(converter.form.saleCurrency, $event)")
							.converter__field.converter__field--buying-currency.flc
								v-field(:field="converter.form.buyingCurrency"
									v-model="converter.form.buyingCurrency.value"
									@update:model-value="fieldChanged(converter.form.buyingCurrency, $event)")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from '../scripts/controller/controller.js';
import linkTargetMixin from '../components/mixins/v-mixin-link-target.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin,
		linkTargetMixin
	],

	props: {
		view: {
			type: String,
			default: 'regular'
		}
	},

	data() {
		return {
			converter: null,
			activeTab: 'exchangeRates', // or "currencyConverter",
			activeExchangeRatesMode: '1', // or "in-app" or "in-cards",
			localFormData: new FormData(),
			fieldChangedTimeout: null,
			loading: false,
			currentDeal: 'SALE',
			deviceData: window.deviceData,
			backgroundImage: '/local/assets/images/converter.jpg',
		};
	},

	computed: {
		currentDealKey() {
			return this.currentDeal.toLowerCase();
		},

		oppositeDealKey() {
			return this.currentDeal === 'SALE' ? 'buying' : 'sale';
		}
	},

	methods: {
		setDisabledCurrencyOption() {
			this.converter.form.buyingCurrency.options.forEach(item => {
				item.disabled = false;
			});
			this.converter.form.saleCurrency.options.forEach(item => {
				item.disabled = false;
			});
			let saleCurrencyValue = this.converter.form.saleCurrency.value;
			let buyingCurrencyValue = this.converter.form.buyingCurrency.value;
			this.converter.form.buyingCurrency.options.find(item => item.value === saleCurrencyValue).disabled = true;
			this.converter.form.saleCurrency.options.find(item => item.value === buyingCurrencyValue).disabled = true;
		},

		fieldChanged(field, $event) {
			// if keys from 0 to 9 or "," was pressed
			if ($event && $event.keyCode && (($event.keyCode && ($event.keyCode >= 48 && $event.keyCode <= 57) || (96 <= $event.keyCode && $event.keyCode <= 105)) || $event.keyCode === 190 || $event.keyCode === 191 || $event.keyCode === 8) || field.name === 'SALE_CURRENCY' || field.name === 'BUYING_CURRENCY' || field.name === 'SALE') {
				if (field.name === 'SALE' || field.name === 'BUYING') {
					this.currentDeal = field.name;
					this.updateConverterValues();
				} else if (field.name === 'SALE_CURRENCY' || field.name === 'BUYING_CURRENCY') {
					this.updateConverterValues();
					this.setDisabledCurrencyOption();
				}
				if (this.converter.form.buying.value === 0) {
					this.converter.form.buying.value = '';
				}
				if (this.converter.form.sale.value === 0) {
					this.converter.form.sale.value = '';
				}
			}
		},

		updateConverterValues() {
			this.converter.form[this.oppositeDealKey].value = +this.converter.form[this.currentDealKey].value * this.converter.converterRates.find(item => item.name === this.converter.form[`${this.currentDealKey}Currency`].value).rates[this.oppositeDealKey][this.converter.form[`${this.oppositeDealKey}Currency`].value];
		},

		swapFields() {
			let saleCurrencyValue = this.converter.form.saleCurrency.value;
			let buyingCurrencyValue = this.converter.form.buyingCurrency.value;
			let tempValue = saleCurrencyValue;
			saleCurrencyValue = buyingCurrencyValue;
			buyingCurrencyValue = tempValue;
			this.converter.form.saleCurrency.value = saleCurrencyValue;
			this.converter.form.buyingCurrency.value = buyingCurrencyValue;
			if (this.converter.form.sale.value === '0') {
				this.converter.form.sale.value = '';
				this.converter.form.buying.value = '';
				return;
			}
			this.updateConverterValues();
			this.setDisabledCurrencyOption();
		},

		proxyFieldName(name) {
			return `state[form][${name}]`;
		},

		dataSet(data) {
			this.converter = data;
			this.activeExchangeRatesMode = "address1";
			this.setDisabledCurrencyOption();
		}
	}
};
</script>